import React from "react";
import moment from "moment";
import A12Y_CONST from "../common/a12yConst";

function PopUpNewDependentConfirmation({
  popUpStatus,
  onClose,
  onConfirm,
  popUpType,
  activationFee,
  subscription,
  currentCount = 0,
  proratedAmount = 0,
  nextBill = 0,
}) {
  if (!popUpStatus) return null;

  let title = "New Dependent Confirmation";
  let description2 = "Adding a new dependent will change your Advocord subscription plan. Today, your card on file will be charged a pro-rated monthly fee of:";
  let description = "Adding a new dependent will change your Advocord subscription. Your card on file will be charged a pro-rated monthly fee of:";
  let showBillingDetails = false;
  let secondaryButtonText = "Manage Dependents";
  let secondaryButtonId = "ManageDependentsBtn";

  if (popUpType === A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED) {
    title = "New Dependent Confirmation";
    // description = "Adding a new dependent will change your Advocord subscription plan. Today, your card on file will be charged a pro-rated monthly fee of:";
    description = "Adding a new dependent will change your Advocord subscription. Your card on file will be charged a pro-rated monthly fee of:";
    showBillingDetails = true;
    secondaryButtonText = "Manage Dependents";
    secondaryButtonId = "ManageDependentsBtn";
  } else if (popUpType === A12Y_CONST.LABEL.TRIAL_HAS_EXPIRED) {
    title = "Your current Trial has expired.";
    description = "Please subscribe to continue adding dependents.";
    showBillingDetails = false;
    secondaryButtonText = "Cancel";
    secondaryButtonId = "CancelBtn";
  } else if (popUpType === A12Y_CONST.LABEL.CANCELLED) {
    title = "Your subscription is cancelled.";
    description = "Please re-activate your subscription to add more dependents.";
    showBillingDetails = false;
    secondaryButtonText = "Cancel";
    secondaryButtonId = "CancelBtn";
  } else if (popUpType === A12Y_CONST.LABEL.DOWNGRADE_CONFIRMATION) {
    title = "Confirm Deactivation";
    description = "Deactivating a dependent will downgrade your Advocord subscription.";
    showBillingDetails = true;
    secondaryButtonText = "Cancel";
    secondaryButtonId = "CancelBtn";
  } else if (popUpType === "CREDIT_INFO_SAVED") {
    title = "Your credit information is saved.";
    description = "You can now proceed with adding your dependent.";
    showBillingDetails = false;
    secondaryButtonText = "Cancel";
    secondaryButtonId = "CancelBtn";
  }

  // Quota calculation logic for billing details
  const planAmount = subscription?.price_details?.plan_amount || 0;
  const planInterval = subscription?.price_details?.plan_interval_display || '';
  const renewalDate = subscription?.renewal_date || subscription?.subscription_details?.renewal_date;
  const nextBillFormatted = renewalDate ? moment(new Date(renewalDate)).format('MMMM D, YYYY') : '';
  const percentOff = subscription?.price_details?.percent_off;
  const amountOff = subscription?.price_details?.amount_off;
  const hasDiscount = (percentOff != null && percentOff > 0) || (amountOff != null && amountOff > 0);
  const discountText = amountOff ? `$${amountOff.toFixed(2)} Discount` : percentOff ? `($${((planAmount * percentOff / 100) * (currentCount + 1)).toFixed(2)}) | ${percentOff}% Discount` : '';
  const perUnitAfterDiscount = amountOff ? (planAmount - amountOff) : percentOff ? (planAmount - (planAmount * percentOff / 100)) : planAmount;
  const totalBilled = (perUnitAfterDiscount * (currentCount + 1)).toFixed(2);

  return (
    <div className="popTop ndcPopup__overlay">
      <div className="popContainer popMaxWidth">
        <div className="popMaster">
          <div className="popUpMainBg fullWidth ndcPopup__body">
            {/* Exclamation Icon */}
            <div className="cancelIcon fullWidth marginTopBottom20">
              {popUpType === A12Y_CONST.LABEL.DOWNGRADE_CONFIRMATION ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
                  <path d="M29 5.8C16.1869 5.8 5.8 16.1878 5.8 29C5.8 41.8122 16.1869 52.2 29 52.2C41.8131 52.2 52.2 41.8122 52.2 29C52.2 16.1878 41.8131 5.8 29 5.8ZM0 29C0 12.9833 12.9839 0 29 0C45.0161 0 58 12.9833 58 29C58 45.0167 45.0161 58 29 58C12.9839 58 0 45.0167 0 29Z" fill="#D83933" />
                  <path d="M29.0001 34.7996C27.3984 34.7996 26.1001 33.5004 26.1001 31.8996V14.4996C26.1001 12.8988 27.3984 11.5996 29.0001 11.5996C30.6018 11.5996 31.9001 12.8988 31.9001 14.4996V31.8996C31.9001 33.5004 30.6018 34.7996 29.0001 34.7996Z" fill="#D83933" />
                  <path d="M24.6499 42.0512C24.6499 39.65 26.5975 37.7012 28.9999 37.7012C31.4023 37.7012 33.3499 39.65 33.3499 42.0512C33.3499 44.4524 31.4023 46.4012 28.9999 46.4012C26.5975 46.4012 24.6499 44.4524 24.6499 42.0512Z" fill="#D83933" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 82 82" fill="none">
                  <rect x="37.1328" y="19.3396" width="7.73585" height="31.717" fill="#2d6cb2" />
                  <circle cx="40.9999" cy="60.3395" r="4.64151" fill="#2d6cb2" />
                  <path fillRule="evenodd" clipRule="evenodd"
                    d="M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82ZM40.9996 75.0378C59.7982 75.0378 75.0374 59.7986 75.0374 41.0001C75.0374 22.2016 59.7982 6.96235 40.9996 6.96235C22.2011 6.96235 6.96191 22.2016 6.96191 41.0001C6.96191 59.7986 22.2011 75.0378 40.9996 75.0378Z"
                    fill="#2d6cb2" />
                </svg>
              )}
            </div>

            {/* Title */}
            <div className="areYouText areYouDmFont texAlingCener">
              {title}
            </div>

            {/* Description */}
            <div className="useInfo ndcPopup__subtitle">
              {description}
            </div>

            {showBillingDetails ? (
              <>
                {popUpType !== A12Y_CONST.LABEL.DOWNGRADE_CONFIRMATION && (
                  <>
                    {/* Pro-rated amount */}
                    <div className="fullWidth texAlingCener marginTop15 marginBottom15 ndcPopup__amount">
                      ${proratedAmount.toFixed(2)}
                    </div>
                  </>
                )}

                {/* Next bill info */}
                <div className="useInfo ndcPopup__subtitle">
                  {popUpType === A12Y_CONST.LABEL.DOWNGRADE_CONFIRMATION
                    ? `Your next bill on ${nextBillFormatted} will adjust to:`
                    : `Your next monhtly bill on  ${nextBillFormatted} will adjust to:`}
                </div>

                {/* Plan Details Section */}
                <div className="fullWidth marginTop20 ndcPopup__details">
                  <div className="ndcPopup__row">
                    
                    <div className="ndcPopup__value">
                      {/* <div className="ndcPopup__planName ndcPopup__planName--themed">Professional Plan</div> */}
                      {/* <div className="ndcPopup__planBox ndcPopup__planBox--warm">
                        {planInterval} ${planAmount}
                      </div>
                      <div className="ndcPopup__planNote">
                        Prices are mentioned in US currency and do not include applicable taxes
                      </div> */}
                    </div>
                  </div>

                  <div className="ndcPopup__row ndcPopup__row--center">
                    <div className="ndcPopup__label">Active Dependents</div>
                    <div className="ndcPopup__countBox ndcPopup__countBox--green">
                      {popUpType === A12Y_CONST.LABEL.DOWNGRADE_CONFIRMATION ? currentCount - 1 : currentCount + 1}
                    </div>
                  </div>

                  {hasDiscount && (
                    <div className="ndcPopup__row ndcPopup__row--center">
                      <div className="ndcPopup__label">Discount Applied:</div>
                      <div className="ndcPopup__value ndcPopup__discountValue">{discountText}</div>
                    </div>
                  )}
                </div>

                {/* Total billed */}
                <div className="fullWidth texAlingCener ndcPopup__totalBilled ndcPopup__totalBilled--warm">
                  {subscription?.subscription_details.subscription_status.toLowerCase() === 'trialing' ? (
                    `Your next bill will be $${(currentCount - 1) * planAmount}.`
                  ) : (
                    popUpType === A12Y_CONST.LABEL.DOWNGRADE_CONFIRMATION
                      ? `Your next monthly bill will be $${nextBill.toFixed(2)}`
                      : `$${proratedAmount.toFixed(2)} will be charged today`
                  )}
                </div>

              </>
            ) : null}

            {/* Buttons */}
            <div className="fullWidth marginTop30 marginBottom20 ndcPopup__buttons">
              <div id={secondaryButtonId} className="popUpYesButton ndcPopup__btn" onClick={onClose}>
                Cancel
              </div>
              <div id="ConfirmBtn" className="popUpNoButton ndcPopup__btn" onClick={onConfirm}>
                Confirm
              </div>
            </div>
            {popUpType === A12Y_CONST.LABEL.DOWNGRADE_CONFIRMATION && (
              <div className='popUpnoteBottom'>{`Note: If this dependent is reactivated in the future, a one-time reactivation fee of $${subscription?.subscription_details.subscription_status.toLowerCase() === 'trialing' ? "0.00" : activationFee} will be charged.`}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopUpNewDependentConfirmation;
